module.exports = {
  MY_ACCOUNT: 'My Account',
  MY_TEAM: 'My Team',
  WHATSNEW: "What's New",
  MY_PLAN: 'My Plan',
  UPGRADE_PLAN: 'Upgrade Plan',
  // Main app header (MainHeader.vue) — used as the analytics `source` for surfaces
  // opened directly from the header (e.g. HeaderUpgradeModal) so their Mixpanel/GA4
  // events are attributed to the header, not whatever page happened to be underneath.
  HEADER: 'Header',
  PAYMENT: 'Payment',
  HOME: 'Home',
  PRESENTATION_APP: 'Presenter App',
  PRESENTATION_LIST: 'Presentation List',
  PRESENTATION_EDITOR: 'Presentation Editor',
  PRESENTATION_REPORT: 'Presentation Report',
  PRESENTATION_BACKSTAGE: 'Presentation Backstage',
  PRESENTING_MODE: 'Presenting Mode',
  PRESENTATION_PREVIEW: 'Presentation Preview',
  PRESENTER_REGISTER: 'Presenter Register',
  PRESENTER_LOGIN: 'Presenter Login',
  PRESENTER_FORGOTPASSWORD: 'Presenter Forgot Password',
  // AHA-46346: shared-contract value, intentionally unreferenced in this repo.
  // The onboarding child app is a separate iframe project and cannot import this
  // constant, so it hardcodes the literal 'Onboarding' on its side; this entry is
  // the single source of truth documenting that the category name is reserved and
  // owned. The child emits eventAction 'Header > language > Select language' (same
  // as MultipleLanguage.vue) under this category, keeping onboarding language
  // switches separable from sign-up / dashboard ones in GA4.
  ONBOARDING: 'Onboarding',
  TEMPLATE_LIBRARY: 'Template library',
  EDITOR_TEMPLATE_LIBRARY: 'In-Editor template library',
  SHARE_WITH_ME: 'Shared with Me',
  REFER_FRIEND: 'Refer a Friend',
  CATEGORY_PUBLIC_TEMPLATE_DEMO_MODE: 'Public Template > Demo mode',
  CATEGORY_PUBLIC_TEMPLATE_LISTING: 'Public Template Listing',
  MS_TEAMS_APP: 'Microsoft Teams App',
  PRESENT_EMBED: 'Present Embed',
  EMBED: 'Embed',
  MARKETPLACE: 'Marketplace',
  ADMIN_ANALYTICS: 'Admin Analytics',
  REPORT_SESSION: 'Sessions Report',
}
